import { apiFetch } from './http';

/**
 * Agency-side visibility of portal submissions (full-live-cutover §3.6).
 * GET /api/clients/requests is the cross-tenant triage read: agency roles
 * only (the backend 403s client tokens), newest-first, capped at 100, each
 * row carrying clientId so the Cockpit feed shows WHICH tenant filed it.
 * This completes the §2→§3 integration path: a portal submission becomes
 * visible on the platform side in the same session.
 */

/** All tenants' requests, newest first (agency roles only). */
export function listAllClientRequests() {
  return apiFetch('/api/clients/requests');
}
